import { v4 as uuid } from 'uuid';
export class Address {
    id;
    name = null;
    street = null;
    zip = null;
    city = null;
    countryCode = null;
    vatId = null;
    isCompany = false;
    isComplete() {
        if (!this.id || this.id.length <= 0) {
            return false;
        }
        if (!this.name || this.name.length <= 0) {
            return false;
        }
        if (!this.street || this.street.length <= 0) {
            return false;
        }
        if (!this.zip || this.zip.length <= 0) {
            return false;
        }
        if (!this.city || this.city.length <= 0) {
            return false;
        }
        if (!this.countryCode || this.countryCode.length <= 0) {
            return false;
        }
        if (this.isCompany) {
            if (!this.vatId || this.vatId.length <= 0) {
                return false;
            }
        }
        return true;
    }
    constructor(id, data) {
        if (id && typeof id == 'string') {
            this.id = id || uuid();
        }
        else if (id && typeof id == 'object' && typeof id.id == 'string') {
            this.id = id.id;
        }
        else {
            this.id = uuid();
        }
        if (id && typeof id == 'object') {
            data = id;
        }
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
